import { FormattingRule } from '@ardoq/perspectives';
import {
  APIEntityType,
  FilterInfoOperator,
  FormattingFilter,
  FilterTypes,
} from '@ardoq/api-types';
import { v4 as uuidv4 } from 'uuid';
import { legacyAffectsTypeNames } from '@ardoq/filter-interface';

export const mapToPerspectiveEditorFormattingRule = (
  formattingFilter: FormattingFilter
): FormattingRule | null => {
  if (formattingFilter.type === FilterTypes.TAG) {
    return {
      type: APIEntityType.TAG,
      __id: uuidv4(),
      isInverted: formattingFilter.isNegative,
      isCollapsed: formattingFilter.isCollapsed,
      color: formattingFilter.color,
      value: (formattingFilter.value as string) || undefined,
      version: formattingFilter.version ?? 0,
    };
  }
  if (formattingFilter.type === FilterTypes.ATTRIBUTE) {
    return {
      type: formattingFilter.affectComponent
        ? APIEntityType.COMPONENT
        : APIEntityType.REFERENCE,
      field: formattingFilter.name,
      comparator: formattingFilter.comparator as FilterInfoOperator,
      value: formattingFilter.value,
      __id: uuidv4(),
      isInverted: formattingFilter.isNegative,
      isCollapsed: formattingFilter.isCollapsed,
      // TODO(typeName-migration): Remove legacyAffectsTypeNames, use affectsTypeNames directly.
      typeNames: legacyAffectsTypeNames(
        formattingFilter.affectsTypeName,
        formattingFilter.affectsTypeNames
      ),
      color: formattingFilter.color,
      version: formattingFilter.version ?? 0,
    };
  }
  return null;
};
